module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"like_text":"有幫助","unlike_text":"沒幫助","already_submitted":"已选定。请刷新浏览器:)","comment":"回帖"}}')
  delete Component.options._Ctor
}
